var enUsTranslation = {
    "contact_us.buttonText": "Help",
    "contact_us.error.email": "Please enter a valid email",
    "contact_us.error.general": "Oops... Something went wrong. Please try again.",
    "contact_us.error.minimum_two_chars": "Should be at least 2 chars long",
    "contact_us.placeholders.email": "Email Address",
    "contact_us.placeholders.name": "Full Name",
    "contact_us.placeholders.text": "How can we help?",
    "contact_us.send": "Send",
    "contact_us.subtitle": "Fill in your details, write your question, and we will get back to you",
    "contact_us.success.ok": "Ok",
    "contact_us.success.subtitle": "We got your message and will get back to you as soon as possible.",
    "language.select.label": "Select your language",
    "contact_us.success.title": "Thanks {{name}}!",
    "contact_us.title": "Ask us anything",
    "cookie_consent.customize.categories.essential.description": "These are meant to give you our very best experience and operate the site without sharing personal identifiable information to 3rd parties",
    "cookie_consent.customize.categories.essential.title": "Essential Cookies (always on)",
    "cookie_consent.customize.categories.performance.description": "These help us measure performance and analyze visits to our site so we can keep improving our experience, and enables us to personalize offers",
    "cookie_consent.customize.categories.tracking.description": "These are marketing cookies that help us to provide the most personalized offers",
    "cookie_consent.customize.personalInfo.block1.title": "Do not share my personal information",
    "cookie_consent.customize.personalInfo.block1.description": "We use information collected through cookies to give you the best experiences we can. But, no worries, you can opt out from them at any time. As a California resident you have rights around the sale of personal information.",
    "cookie_consent.customize.personalInfo.block3.description": "If you have an account with us and want to change, or delete your data, email us at privacy@lemonade.com or call us toll-free at 844-733-8666",
    "cookie_consent.customize.categories.performance.title": "Performance Cookies",
    "cookie_consent.customize.categories.tracking.title": "Targeting/advertising cookies",
    "cookie_consent.customize.confirm_btn_title": "Confirm",
    "cookie_consent.customize.title": "Customize cookies",
    "cookie_consent.information.accept_btn_title": "Accept all",
    "cookie_consent.information.cookies_policy_link_text": "Cookies Policy",
    "cookie_consent.information.customize_btn_title": "Customize",
    "cookie_consent.information.reject_btn_title": "Reject all",
    "cookie_consent.information.description": "We use cookies and other technologies to provide you with the best possible user experience and to personalize advertising on and off our website. In addition, our partners may use cookies or other technologies to provide you with marketing information. If you’d like to deactivate all non-essential cookies, hit Customize. You can find out more about how we use cookies and your right to opt-out in our Cookies Policy.",
    "cookie_consent.information.title": "lemonade and cookies",
    "cxai.browser_toast": "For an optimal chat experience we recommend\nChrome, Safari, or Edge browsers",
    "cxai.default_description": "Personal Insurance Assistant",
    "cxai.error.message": "Something went wrong...",
    "cxai.error.retry": "RETRY",
    "cxai.phone_input.mobile_title": "Country Code",
    "cxai.phone_input.no_results": "NO RESULTS",
    "cxai.phone_input.placeholder": "Find your country",
    "cxai.restart.action": "YES",
    "cxai.restart.close": "NO",
    "cxai.restart.content": "Would you like help with\nsomething else?",
    "cxai.restart.title": "Start Over",
    "error_page.action": "Take me home",
    "error_page.subtitle": "Couldn't find the page you were looking for.",
    "error_page.title": "Oops.",
    "footer.disclaimer": "Property and casualty insurance is provided by Lemonade Insurance Company (LIC) and Metromile Insurance Company (MIC), 5 Crosby St., 3rd floor, New York, NY 10013. Home insurance policies in Kansas, Kentucky, Minnesota, North Carolina, New Mexico and Utah are underwritten by member companies of Homesite Group, Inc., 1 Federal Street, Suite 400, Boston, MA 02110. Member companies include: Homesite Insurance Company of the Midwest, Homesite Insurance Company, and Homesite Indemnity Company. Home insurance features, prices, coverages, and available discounts may vary by state and are subject to qualifications. Coverage is subject to policy terms and conditions and may not be available in all states.\n\nLemonade Insurance Agency, LLC (LIA) and Metromile Insurance Services LLC (MIS) are licensed insurance agents and appointed by LIC and MIC and both LIA and MIS receive compensation based on the premiums for the insurance policies each sells. Further information is available upon request.\n\nLemonade Life Insurance Agency, LLC (LLIA) is acting as the agent of Legal & General America, whose life insurance products are underwritten and issued by Banner Life Insurance Company Urbana. Banner products are distributed in 49 states and in DC. Banner Life is not authorized as an insurer and does not do business in New York. The Legal & General America companies are part of the worldwide Legal & General Group. OPTerm policy form # ICC21-DTCV and state variations. Premiums based on preferred plus non-tobacco, preferred non-tobacco, standard plus non-tobacco, standard non-tobacco, preferred tobacco and standard tobacco underwriting classes. Policy descriptions provided here are not a statement of contract. Please refer to the policy forms for full disclosure of all benefits and limitations. LLIA receives compensation for the insurance policies it sells. Products or issue ages may not be available in all jurisdictions. Limitations or restrictions may apply. Our application asks about your lifestyle and health.\n\nCar policies in Texas are underwritten by Home State County Mutual Insurance Company, 4315 Lake Shore Dr J, Waco, TX 76710.",
    "footer.titles.company": "company",
    "footer.titles.features": "features",
    "footer.titles.get_app": "get our app",
    "footer.titles.products": "products",
    "footer.titles.resources": "resources",
    "footer.titles.social": "follow us",
    "footer.titles.contact": "contact us",
    "footer.titles.renters": "renters",
    "footer.titles.car": "car",
    "footer.titles.pet": "pet",
    "footer.titles.homeowners": "homeowners",
    "footer.titles.life": "life",
    "header.actions.login": "My Account",
    "header.actions.logout": "Logout",
    "header.actions.settings": "Settings",
    "header.accessibility.title": "Accessibility",
    "header.bundles.title": "Bundles",
    "header.api.title": "API",
    "header.blank.title": "",
    "header.blog.title": "Blog",
    "header.car.title": "Car",
    "header.car_explained.title": "Car Insurance Hub",
    "header.home_explained.title": "Home Insurance Hub",
    "header.life_explained.title": "Life Insurance Hub",
    "header.pet_explained.title": "Pet Insurance Hub",
    "header.renters_explained.title": "Renters Insurance Hub",
    "header.claims.title": "Claims",
    "header.community.title": "Community",
    "header.covid_19.title": "COVID-19",
    "header.faq.title": "FAQ",
    "header.giveback.title": "Giveback",
    "header.giveback_2021.title": "Giveback",
    "header.global_expansion.title": "Where We're Live",
    "header.home.title": "Home",
    "header.homeowners.title": "Homeowners",
    "header.imprint.title": "Imprint",
    "header.insurance_card.title": "Insurance Card",
    "header.insuropedia.title": "Insurance Dictionary",
    "header.investors.title": "Investor Relations",
    "header.legal_stuff.title": "Legal Stuff",
    "header.life.title": "Life",
    "header.makers.title": "Join the Team",
    "header.manage_cookies.title": "Manage Cookies",
    "header.do_not_share_my_personal_information.title": "Do not share my personal information",
    "header.partners_program.title": "Partners Program",
    "header.pet.title": "Pet",
    "header.pet_cat_insurance_explained.title": "Cat Insurance",
    "header.pet_dog_insurance_explained.title": "Dog Insurance",
    "header.pet_insurance.title": "Pet Health",
    "header.policy_two.title": "Policy 2.0",
    "header.privacy_policy.title": "Privacy Pledge",
    "header.renters.title": "Renters",
    "header.reviews.title": "Reviews",
    "header.pet_compare.title": "Compare Pet Insurance",
    "header.sitemap.title": "Sitemap",
    "header.term_life.title": "Term Life Insurance",
    "header.terms_of_service.title": "Terms of Service",
    "header.transparency.title": "Transparency",
    "nav.accessibility.title": "Accessibility",
    "nav.bundles.title": "Bundles",
    "nav.api.title": "API",
    "nav.blank.title": "",
    "nav.blog.title": "Blog",
    "nav.car.title": "Car Insurance",
    "nav.car_explained.title": "Explaining Car",
    "nav.home_explained.title": "Explaining Homeowners",
    "nav.life_explained.title": "Explaining Life",
    "nav.pet_explained.title": "Explaining\xa0Pet",
    "nav.renters_explained.title": "Explaining Renters",
    "nav.claims.title": "Claims",
    "nav.community.title": "Community",
    "nav.covid_19.title": "COVID-19",
    "nav.faq.title": "FAQ",
    "nav.giveback.title": "Giveback",
    "nav.giveback_2021.title": "Giveback",
    "nav.global_expansion.title": "Where We're Live",
    "nav.home.title": "Home",
    "nav.homeowners.title": "Homeowners Insurance",
    "nav.imprint.title": "Imprint",
    "nav.insurance_card.title": "Insurance Card",
    "nav.insuropedia.title": "Insurance Dictionary",
    "nav.investors.title": "Investor Relations",
    "nav.legal_stuff.title": "Legal Stuff",
    "nav.life.title": "Life Insurance",
    "nav.makers.title": "Join the Team",
    "nav.manage_cookies.title": "Manage Cookies",
    "nav.do_not_share_my_personal_information.title": "Do not share my personal information",
    "nav.partners_program.title": "Partners Program",
    "nav.pet.title": "Pet Insurance",
    "nav.pet_insurance_main_page.title": "Pet Insurance",
    "nav.pet_cat_insurance_explained.title": "Cat Insurance",
    "nav.pet_dog_insurance_explained.title": "Dog Insurance",
    "nav.car_insurance_by_vehicle.title": "Car Insurance by Vehicle",
    "nav.pet_insurance.title": "Pet Health",
    "nav.policy_two.title": "Policy 2.0",
    "nav.privacy_policy.title": "Privacy Pledge",
    "nav.renters.title": "Renters Insurance",
    "nav.reviews.title": "Reviews",
    "nav.global_reviews.title": "Reviews",
    "nav.pet_compare.title": "Compare Pet Insurance",
    "nav.sitemap.title": "Sitemap",
    "nav.term_life.title": "Term Life Insurance",
    "nav.terms_of_service.title": "Terms of Service",
    "nav.transparency.title": "Transparency",
    "nav.global_transparency.title": "Transparency",
    "nav.renters_insurance.title": "Renters Insurance",
    "nav.renters_insurance_main_page.title": "Renters Insurance",
    "nav.complaints.title": "Complaints",
    "nav.explaining_renters.title": "Renters Insurance Hub",
    "nav.explaining_homeowners.title": "Home Insurance Hub",
    "nav.explaining_car.title": "Car Insurance Hub",
    "nav.explaining_pet.title": "Pet Insurance Hub",
    "nav.explaining_life.title": "Life Insurance Hub",
    "nav.what_is_renters_insurance.title": "What is Renters Insurance",
    "nav.renters_insurance_coverage.title": "Renters Insurance Coverage",
    "nav.renters_insurance_cost.title": "Renters Insurance Cost",
    "nav.how_to_get_renters_insurance.title": "How to Get Renters Insurance",
    "nav.car_and_renters_bundle.title": "Car and Renters Bundle",
    "nav.car_insurance.title": "Car Insurance",
    "nav.car_insurance_main_page.title": "Car Insurance",
    "nav.pay_per_mile_car_insurance.title": "Pay Per Mile Car Insurance",
    "nav.car_insurance_coverage.title": "Car Insurance Coverage",
    "nav.car_insurance_cost.title": "Car Insurance Cost",
    "nav.comprehensive_car_insurance.title": "Comprehensive Car Insurance",
    "nav.dog_insurance.title": "Dog Insurance",
    "nav.cat_insurance.title": "Cat Insurance",
    "nav.compare_pet_insurance.title": "Compare Pet Insurance",
    "nav.pet_insurance_coverage.title": "Pet Insurance Coverage",
    "nav.pet_insurance_cost.title": "Pet Insurance Cost",
    "nav.investor_relations.title": "Investor Relations",
    "nav.homeowners_insurance.title": "Homeowners Insurance",
    "nav.homeowners_insurance_main_page.title": "Homeowners Insurance",
    "nav.what_is_homeowners_insurance.title": "What is Homeowners Insurance",
    "nav.homeowners_insurance_coverage.title": "Homeowners Insurance Coverage",
    "nav.homeowners_insurance_cost.title": "Homeowners Insurance Cost",
    "nav.how_much_home_insurance_do_i_need.title": "How Much Home Insurance Do I Need",
    "nav.car_and_home_bundle.title": "Car and Home Bundle",
    "nav.home_insurance.title": "Home Insurance",
    "nav.term_life_insurance.title": "Term Life Insurance",
    "nav.term_life_insurance_main_page.title": "Term Life Insurance",
    "nav.life_insurance_coverage.title": "Life Insurance Coverage",
    "nav.no_exam_life_insurance.title": "No Exam Life Insurance",
    "nav.how_does_life_insurance_work.title": "How Does Life Insurance Work",
    "nav.how_much_life_insurance_do_i_need.title": "How Much Life Insurance Do I Need",
    "nav.contingent_beneficiary.title": "Contingent Beneficiary",
    "privacy_banner.content": "We use cookies and other technologies to give you the best possible user experience and to customize advertising on and off our website. In addition, our partners may use cookies and other technologies to provide you with marketing information. Read more about this and your right to opt-out in our [Privacy Policy](privacyPolicyLink).",
    "privacy_banner.cta": "accept",
    "payment.quote.payment.card_number": "Card Number",
    "payment.quote.payment.iban": "IBAN",
    "payment.quote.payment.errors.account_problem": "We couldn’t process your payment, please contact our team",
    "payment.quote.payment.errors.blocked_postal_codes": "We're sorry, but due to current events in your area we can't accept payments at the moment",
    "payment.quote.payment.errors.card_decline": "Your card was declined. Try a different one.",
    "payment.quote.payment.errors.card_not_supported": "This card type isn't supported.",
    "payment.quote.payment.errors.credit_card_date": "Oops, double check your card's expiration date",
    "payment.quote.payment.errors.credit_card_number": "Oops, can you check your card number again?",
    "payment.quote.payment.errors.generic": "We're having some connectivity problems. Please try again.",
    "payment.quote.payment.stripe.incorrect_number": "The card number is incorrect",
    "payment.quote.payment.stripe.insufficient_funds": "The card has insufficient funds to complete the purchase",
    "payment.quote.payment.stripe.pin_required": "The card has been declined as it requires a PIN",
    "payment.quote.payment.stripe.processing_error": "An error occurred while processing the card",
    "steps.confirmation.back": "Back",
    "steps.confirmation.continue.car": "go to car",
    "steps.confirmation.continue.checkout": "go to checkout",
    "steps.confirmation.continue.home": "go to home",
    "steps.confirmation.continue.life": "go to life",
    "steps.confirmation.continue.pet": "go to pet",
    "steps.confirmation.continue.renters": "go to renters",
    "steps.confirmation.subtitle": "If you don’t finish this quote now, you’ll have to start it over from the beginning.",
    "steps.confirmation.title.car": "Leave Car Quote?",
    "steps.confirmation.title.home": "Leave Home Quote?",
    "steps.confirmation.title.life": "Leave Life Quote?",
    "steps.confirmation.title.pet": "Leave Pet Quote?",
    "steps.confirmation.title.renters": "Leave Renters Quote?",
    "payment.quote.payment.stripe.unknown_reason": "The card has been declined for an unknown reason",
    "cookie_consent.email.section.title": "Targeted advertising linked to your email",
    "cookie_consent.email.section.description": "In some cases, we might use your email address or similar information to provide targeted ads about our bundles and other products to you on third party platforms (like Facebook or Google). If you’re not into that, no problem! Just enter your email below and we won’t share it with third parties for targeted advertising purposes.",
    "cookie_consent.email.section.error.message": "Oops this email is invalid, we won’t be able to delete any data without a valid email address!",
    "cookie_consent.email.input.placeholder": "Email Address"
};

export { enUsTranslation as default };
